/*
 *
 * DivisionAnalysis actions
 *
 */

import {
  GET_DRILLDOWN_DIVISIONS_WATCHER,
  GET_DRILLDOWN_DIVISIONS_SUCCESS,
  GET_DRILLDOWN_DIVISIONS_FAILED,
  GET_DIMENSIONS_WATCHER,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_FAILED,
  GRAPHIC_BARS_WATCHER,
  GRAPHIC_BARS_SUCCESS,
  GRAPHIC_BARS_FAILED,
  DIVISION_WITH_ENGAGEMENT_SUCCESS,
  DIVISION_WITH_ENGAGEMENT_WATCHER,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_WATCHER,
  GET_MEASURE_SUCCESS,
} from "./constants"

export function graphicBarsWatcher(payload) {
  return {
    type: GRAPHIC_BARS_WATCHER,
    payload,
  }
}

export function graphicBarsSuccess(payload) {
  return {
    type: GRAPHIC_BARS_SUCCESS,
    payload,
  }
}

export function graphicBarsFailed() {
  return { type: GRAPHIC_BARS_FAILED }
}

export function getDivisionsWatcher(payload) {
  return {
    type: GET_DRILLDOWN_DIVISIONS_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_DRILLDOWN_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getDivisionsFailed() {
  return { type: GET_DRILLDOWN_DIVISIONS_FAILED }
}

export function getDimensionsWatcher(payload) {
  return {
    type: GET_DIMENSIONS_WATCHER,
    payload,
  }
}

export function getDimensionsSuccess(payload) {
  return {
    type: GET_DIMENSIONS_SUCCESS,
    payload,
  }
}

export function getDimensionsFailed() {
  return { type: GET_DIMENSIONS_FAILED }
}

export function getDivisionMeasureRangeColorWatcher(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_WATCHER,
    payload,
  }
}

export function getDivisionMeasureRangeColorSuccess(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_SUCCESS,
    payload,
  }
}

export function getDivisionWithEngagementWatcher(payload) {
  return { type: DIVISION_WITH_ENGAGEMENT_WATCHER, payload }
}

export function getDivisionWithEngagementSuccess(payload) {
  return { type: DIVISION_WITH_ENGAGEMENT_SUCCESS, payload }
}

export function getMeasureWatcher(payload) {
  return { type: GET_MEASURE_WATCHER, payload }
}

export function getMeasureSuccess(payload) {
  return { type: GET_MEASURE_SUCCESS, payload }
}
